import { Chip, Stack, Tooltip } from "@mui/material"

type ContractLabelProps = {
  contractKey: string // example: "ORG#SPGI#DIVISION#DATA_AND_INSIGHTS#CONTRACT#c75d2511-ca9d-40f4-97e8-05db454cc4b6"
}

const ContractLabel = ({ contractKey }: ContractLabelProps) => {
  const keyParts = contractKey.split("#")

  const organisation = keyParts[1] ?? ""
  const division = keyParts[3] ?? ""
  const contractUuid = keyParts[5] ?? ""

  return (
    <Stack direction="row" gap={1}>
      <Tooltip title="Organisation" placement="top" sx={{ bgcolor: "#1b5e20", color: "#ffffff" }}>
        <Chip label={organisation} />
      </Tooltip>

      <Tooltip title="Division" placement="top" sx={{ bgcolor: "#e65100", color: "#ffffff" }}>
        <Chip label={division} />
      </Tooltip>

      <Tooltip title="Contract" placement="top" sx={{ bgcolor: "#01579b", color: "#ffffff" }}>
        <Chip label={contractUuid} />
      </Tooltip>
    </Stack>
  )
}

export default ContractLabel
